/**
 * Leading Reach vocabulary for the referral notes.
 *
 * The `*_CODE` values are the `externalSystemIdentifiers[].code` values Optum sends; the `*_LABEL`
 * values are what those fields are called in the written note. Shared so the notes writer and the
 * observability log agree on them.
 *
 * Note for anyone changing a LABEL: notes already written into customers' charts keep the old
 * spelling forever. `getOptumReferralIdFromNotes` is deliberately independent of these strings —
 * it anchors on line position rather than excluding known labels — so historical notes stay safe.
 */
export const LEADING_REACH_SYSTEM = 'leading-reach';

export const LEADING_REACH_REFERRAL_ID_CODE = 'referralId';
export const LEADING_REACH_STATUS_CODE = 'status';

/** Rendered note labels. The parser does not reference these — see the note above. */
export const LEADING_REACH_REFERRAL_ID_LABEL = 'Leading reach referralID';
export const LEADING_REACH_STATUS_LABEL = 'Leading reach referral status';
